import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EntryService } from '../../../services/entry/entry.service';
@Component({
  selector: 'cm-entry-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
})
export class MessageComponent implements OnInit {
  model: any = {};

  constructor(private _entry: EntryService, private router: Router) {}

  ngOnInit() {
    if (this._entry.getMessageType().email) {
      this.model = this._entry.getMessageType();
    } else {
      this.goToLogin();
    }
  }

  onSignInClick() {
    const { redirectLink }: { redirectLink: any } = this.model;
    if (redirectLink) {
      if (typeof redirectLink === 'string') {
        window.location.replace(redirectLink);
      } else {
        this.router.navigate(redirectLink.link, { queryParams: redirectLink.queryParams });
      }
      return;
    }
    this.goToLogin();
  }

  private goToLogin() {
    this.router.navigate(['/entry/login']);
  }
}
